import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior: function (to, from, savedPosition) {
    if (to.hash) {
      return {selector: to.hash}
    } else if (savedPosition) {
      return savedPosition
    } else {
      return {x: 0, y: 0}
    }
  },
  routes: [
    // redirect renamed drills
    { path: '/arithmetic/aricuwp/*', redirect: '/arithmetic/procuwp/*' },
    { path: '/pre-algebra/aricuwp/*', redirect: '/pre-algebra/procuwp/*' },

    // basic menus
    { path: '/', component: () => import('@/common/Home') },
    { path: '/home', component: () => import('@/common/Home') },
    // { path: '/apps', component: () => import('@/common/Apps') },
    { path: '/books', component: () => import('@/common/Books') },
    // { path: '/help-us-grow', component: () => import('@/common/Grow') },
    { path: '/settings', component: () => import('@/common/Settings') },

    // footer links
    { path: '/terms', component: () => import('@/common/Terms') },
    { path: '/privacy', component: () => import('@/common/Privacy') },
    { path: '/contact', component: () => import('@/common/Contact') },

    // languages dropdown & drills
    { path: '/spanish', component: () => import('@/languages/VocaSpanish') },
    { path: '/spanish/:drill', component: () => import('@/languages/VocaDrill'), props: true },
    { path: '/spanish/:drill/*', component: () => import('@/languages/VocaDrill'), props: true },

    { path: '/korean', component: () => import('@/languages/VocaKorean') },
    { path: '/korean/:drill', component: () => import('@/languages/VocaDrill'), props: true },
    { path: '/korean/:drill/*', component: () => import('@/languages/VocaDrill'), props: true },

    { path: '/french', component: () => import('@/languages/VocaFrench') },
    { path: '/french/:drill', component: () => import('@/languages/VocaDrill'), props: true },
    { path: '/french/:drill/*', component: () => import('@/languages/VocaDrill'), props: true },

    // math dropdown & drills
    { path: '/math-facts', component: () => import('@/math/MathFacts') },
    { path: '/math-facts/:drill', component: () => import('@/math/MathDrill'), props: true },
    { path: '/math-facts/:drill/*', component: () => import('@/math/MathDrill'), props: true },

    { path: '/arithmetic', component: () => import('@/math/Arithmetic') },
    { path: '/arithmetic/:drill', component: () => import('@/math/MathDrill'), props: true },
    { path: '/arithmetic/:drill/*', component: () => import('@/math/MathDrill'), props: true },

    { path: '/pre-algebra', component: () => import('@/math/PreAlgebra') },
    { path: '/pre-algebra/:drill', component: () => import('@/math/MathDrill'), props: true },
    { path: '/pre-algebra/:drill/*', component: () => import('@/math/MathDrill'), props: true },

    { path: '/algebra', component: () => import('@/math/Algebra') },
    { path: '/algebra/:drill', component: () => import('@/math/MathDrill'), props: true },
    { path: '/algebra/:drill/*', component: () => import('@/math/MathDrill'), props: true },

    /* TODO: geometry drills
    { path: '/geometry', component: () => import('@/math/Geometry') },
    { path: '/geometry/:drill', component: () => import('@/math/GeometryDrill'), props: true },
    { path: '/geometry/:drill/*', component: () => import('@/math/GeometryDrill'), props: true },
    */

    // otherwise redirect to home
    { path: '*', redirect: '/' }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js